import React from 'react'
import { Grid } from 'semantic-ui-react'

// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
// @ts-ignore
import LKButton from 'shared/LKButton'

import { getName, isRequired } from '../../../helpers'
import { FORM_NAME } from '../../../constants'
import translate from '../../translate'
import container from './container'

const style = {
  borderBottom: '1px solid rgba(34,36,38,.15)',
}

const AddressInformation = ({
  fields,
  selects,
  cityList,
  dynamicOptions,
  copyAddressFromOfficialAddress,
  onTranslateAltRequest,
  onCountryChange,
}) => (
  <Grid.Row style={style}>
    <Grid.Column>
      <FormLayout
        visible={!!(fields.Address || fields.CityID)}
        fieldProportions="3:3:6:3"
        label={translate('lbl_legal_address')}
      >
        <FormField
          type="select"
          name="CountryID"
          onChange={(value) => onCountryChange(value, 'CityID')}
          options={selects.Country}
          search
        />
        <FormField
          options={cityList.CityIDList}
          visible={!!fields.CityID}
          name={getName(fields.CityID)}
          required={isRequired(fields.CityID)}
          type="select"
          search
        />

        <FormField
          autoFocus
          visible={!!fields.Address}
          name={getName(fields.Address)}
          type="text"
          required={isRequired(fields.Address)}
          maxLength={fields.Address ? fields.Address.MaxLen : -1}
          onBlur={onTranslateAltRequest('Address_ALT')}
        />

        <FormField type="text" name="Address_ALT" placeholder={translate('txt_address2_alt')} />

        <div />
      </FormLayout>

      <FormLayout visible={!!fields.Address2} fieldProportions="3:3:6:3:1" label={translate('lbl_current_address')}>
        <FormField
          type="select"
          name="CountryBusID"
          onChange={(value) => onCountryChange(value, 'CityBusID')}
          options={selects.Country}
          search
        />
        <FormField
          options={cityList.CityBusIDList}
          visible={!!fields.City2ID}
          name="CityBusID"
          required={isRequired(fields.City2ID)}
          flags={
            fields.City2ID && {
              modifies: {
                modifier: 'CityBusID',
                modifierAlias: 'CityID',
                field: { DistrictBusID: selects.District },
                dependent: {
                  modifier: 'DistrictBusID',
                  modifierAlias: 'DistrictID',
                  field: { ZoneBusID: selects.Zone },
                  form: FORM_NAME,
                },
                form: FORM_NAME,
              },
            }
          }
          type="select"
          search
          searchable
        />

        <FormField
          visible={!!fields.Address2}
          name="AddressBus"
          type="text"
          required={isRequired(fields.Address2)}
          maxLength={fields.Address2 ? fields.Address2.MaxLen : -1}
          onBlur={onTranslateAltRequest('AddressBus_ALT')}
        />

        <FormField
          type="text"
          name="AddressBus_ALT"
          placeholder={translate('txt_address_alt')}
          required={isRequired(fields.AddressBus_ALT)}
          maxLength={fields.AddressBus_ALT ? fields.AddressBus_ALT.MaxLen : -1}
        />

        <LKButton alias="down_big" onClick={copyAddressFromOfficialAddress} />
      </FormLayout>

      <FormLayout
        visible={!!(fields.City2ID || fields.DistrictBusID || fields.ZoneBusID)}
        label={translate('lbl_location2')}
      >
        <FormField
          visible={!!fields.DistrictBusID}
          name="DistrictBusID"
          options={dynamicOptions.District}
          type="select"
          search
          required={isRequired(fields.DistrictBusID)}
          searchable
        />

        <FormField
          visible={!!fields.ZoneBusID}
          name="ZoneBusID"
          options={dynamicOptions.Zone}
          required={isRequired(fields.ZoneBusID)}
          type="select"
          search
          searchable
        />
      </FormLayout>
    </Grid.Column>
  </Grid.Row>
)

export default container(AddressInformation)
